import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <main className="min-h-screen bg-[#09090b] text-white">
      <div className="max-w-3xl mx-auto px-6 py-14">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-mono-accent uppercase tracking-[0.3em] text-zinc-400 hover:text-white"
          data-testid="back-link"
        >
          <ArrowLeft className="w-4 h-4" /> zurück
        </Link>

        <h1 className="mt-8 font-display uppercase text-4xl sm:text-5xl tracking-tight">
          Datenschutz
        </h1>

        <section className="mt-10 space-y-6 text-zinc-300 text-sm leading-relaxed">
          <div>
            <h2 className="font-display uppercase text-xl text-white">1. Verantwortlicher</h2>
            <p className="mt-2">
              bestburgerstuttgart.de<br />
              70173 Stuttgart<br />
              Kontakt: gratis@bestburgerstuttgart.de
            </p>
          </div>

          <div>
            <h2 className="font-display uppercase text-xl text-white">2. E-Mail-Eintrag & Gutschein</h2>
            <p className="mt-2">
              Deine E-Mail-Adresse wird ausschließlich zum Versand deines Gratis-Fritten-Gutscheins
              sowie - bei deiner Zustimmung - für gelegentliche Updates rund um BUDDIEZ buns & rolls
              und bestburgerstuttgart.de verwendet.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
              Du kannst deine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen
              (Klick auf „Abmelden" in jeder Mail oder via info@bestburgerstuttgart.de).
            </p>
          </div>

          <div>
            <h2 className="font-display uppercase text-xl text-white">3. Speicherdauer</h2>
            <p className="mt-2">
              Wir speichern deine E-Mail, bis du die Löschung anfragst oder deine Einwilligung widerrufst.
            </p>
          </div>

          <div>
            <h2 className="font-display uppercase text-xl text-white">4. Deine Rechte</h2>
            <p className="mt-2">
              Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch.
              Beschwerderecht bei der zuständigen Aufsichtsbehörde.
            </p>
          </div>

          <div>
            <h2 className="font-display uppercase text-xl text-white">5. Dienstleister</h2>
            <p className="mt-2">
              E-Mail-Versand via Resend (Drittland-Transfer mit Standardvertragsklauseln).
            </p>
          </div>

          <div id="impressum">
            <h2 className="font-display uppercase text-xl text-white">Impressum</h2>
            <p className="mt-2">
              bestburgerstuttgart.de<br />
              70173 Stuttgart<br />
              Kontakt: gratis@bestburgerstuttgart.de
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
